export default function isCypress() {
    var urlParams = new URLSearchParams(window.location.search);
    return urlParams.has('isCypress');
}
